import React, { FC } from 'react';
import { ReactComponent as Plus } from '../../../assets/Common/Plus.svg';

export const PlusIcon: FC = () => <Plus />;
